<template>
    <div
        class="p-card"
        at-p-card
    >
        <TCard
            :token="token"
            :status="status"
            :is-show-payment-proceed-form="isShowPaymentProceedForm"
            :is-disabled="isDisabled"
            :payment-proceed-form-data="paymentProceedFormData"
            :is-card-holder-name-required="isCardHolderNameRequired"
            @changeIframeState="handleChangeIframeState"
            @onSubmit="onSubmit"
        />
    </div>
</template>

<script>
import TCard from '../../templates/t-card';

import EventBus from '../../../utils/event-bus';
import { socket } from '../../../utils/services/websocket-service';
import {
    CHANGE_IS_DISABLED,
    CHANGE_IS_SHOW_LOADER
} from '../../../utils/constants/event-constants';
import { CARD_STATUS } from '../../../utils/constants/status-constants';
import { SOCKET_CONSTANTS } from '../../../utils/constants/websocket-constats';

export default {
    name: 'PCard',
    components: {
        TCard
    },
    props: {
        /**
         * Set token
         */
        token: {
            type: String,
            default: ''
        },
        /**
         * Enable/Disable edit form fields
         */
        isDisabled: {
            type: Boolean,
            default: false
        },
        /**
         * Set payment info
         */
        payment: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            status: '',
            paymentProceedFormData: {},
            isShowPaymentProceedForm: false,
            isPendingIframeRequest: false
        }
    },
    computed: {
        isWait3DsStatus() {
            return this.status === CARD_STATUS.WAIT_3DS;
        },
        isFinalStatus() {
            return [CARD_STATUS.SUCCESS, CARD_STATUS.FAIL].includes(this.status);
        },
        isShowLoaderByStatus() {
            return ![CARD_STATUS.NEW, CARD_STATUS.WAIT_3DS].includes(this.status);
        },
        isCardHolderNameRequired() {
            // eslint-disable-next-line no-prototype-builtins
            return this.payment.hasOwnProperty('cardholder_required')
                ? this.payment.cardholder_required
                : true;
        }
    },
    watch: {
        payment: {
            deep: true,
            immediate: true,
            handler(data) {
                this.handleData(data);
            }
        }
    },
    methods: {
        emitChangeLoader() {
            const isShow = this.isPendingIframeRequest || this.isShowLoaderByStatus;
            EventBus.$emit(CHANGE_IS_SHOW_LOADER, isShow);
        },
        emitChangeIsDisabled(isDisabled = false) {
            this.$emit(CHANGE_IS_DISABLED, isDisabled);
        },
        handleData({ status = '', data = {} }) {
            this.status = status;
            this.paymentProceedFormData = data;
            if (this.isWait3DsStatus) {
                this.isShowPaymentProceedForm = true;
                this.paymentProceedFormData = data;
            } else if (this.isFinalStatus) {
                this.isPendingIframeRequest = false;
            }
            this.emitChangeLoader();
        },
        handleChangeIframeState() {
            this.isPendingIframeRequest = true;
            this.isShowPaymentProceedForm = false;
            this.emitChangeLoader();
        },
        onSubmit(data) {
            this.emitChangeIsDisabled(true);

            const formData = {
                ...data,
                token: this.token
            };

            if (this.payment.on_submit) {
                const handler = (...args) => {
                    formData.payload = args;
                    socket.emit(SOCKET_CONSTANTS.CLIENT_SEND_FORM, formData);
                };
                const beforeSubmitHandler = eval(`(function() {${this.payment.on_submit}; return execute_before_submit;})()`);
                const clearCardCode = data.card.replace(/\D/g, '');
                beforeSubmitHandler(clearCardCode, handler);
            } else {
                socket.emit(SOCKET_CONSTANTS.CLIENT_SEND_FORM, formData);
            }
        }
    }
};
</script>

<style lang="scss">
    @import 'theme';
</style>
